export const DiffVisualColors = {
  // TODO use global palette
  add: 'rgba(255, 247, 230, 1)',
} as const;

export const getReferenceBorderStyle = (color: string) => {
  return `2px dotted ${color}`;
};
